import { createContext, useContext } from 'react';

// Imperative onboarding handlers shared with Layout (footer chip) and Header
// (user menu). OnboardingOrchestrator is the provider.
//
// SEAM FOR FEAT-002: `startTour` is a documented no-op placeholder in FEAT-001.
// FEAT-002 replaces the orchestrator's implementation to boot the driver.js tour
// (ignoring the completed flag). The shape of this context does NOT change —
// FEAT-002 only swaps the function body inside OnboardingOrchestrator.
export interface OnboardingContextValue {
  openReleaseHistory: () => void;
  startTour: () => void;
}

export const OnboardingContext = createContext<OnboardingContextValue>({
  openReleaseHistory: () => {},
  startTour: () => {},
});

export function useOnboarding(): OnboardingContextValue {
  return useContext(OnboardingContext);
}
